(function () {

    function initFAQ() {
        const faqSection = document.querySelector('.faq');
        if (!faqSection) return;

        const buttons = faqSection.querySelectorAll('.faq__button');

        buttons.forEach((button) => {
            button.addEventListener('click', toggleFAQ);
        });
    }

    function initStickyProductCard() {
        const heroBanner = document.querySelector('.lp-hero-banner');
        const stickyCard = document.getElementById('sticky-product-card');
        const footer = document.querySelector('footer');

        if (!heroBanner || !stickyCard) return;

        function updateStickyCardVisibility() {
            const heroBannerRect = heroBanner.getBoundingClientRect();
            const isHeroBannerVisible = heroBannerRect.bottom > 0;

            let isFooterVisible = false;
            if (footer) {
                const footerRect = footer.getBoundingClientRect();
                isFooterVisible = footerRect.top < window.innerHeight;
            }

            if (isHeroBannerVisible || isFooterVisible) {
                stickyCard.classList.remove('is-visible');
            } else {
                stickyCard.classList.add('is-visible');
            }
        }

        window.addEventListener('scroll', updateStickyCardVisibility, { passive: true });
        updateStickyCardVisibility();
    }

    function initCTAScroll() {
        const ctaSection = document.querySelector('.lp-hero-banner__cta-section');
        const earnReasonSection = document.querySelector('.earn-reason');

        if (!ctaSection || !earnReasonSection) return;

        ctaSection.addEventListener('click', function(e) {
            e.preventDefault();

            const targetPosition = earnReasonSection.offsetTop;
            const startPosition = window.scrollY;
            const distance = targetPosition - startPosition;
            const duration = 300;
            let start = null;

            function animation(currentTime) {
                if (start === null) start = currentTime;
                const elapsed = currentTime - start;
                const progress = Math.min(elapsed / duration, 1);

                // Easing function (ease-out-cubic)
                const easeProgress = 1 - Math.pow(1 - progress, 3);

                window.scrollTo(0, startPosition + distance * easeProgress);

                if (elapsed < duration) {
                    requestAnimationFrame(animation);
                }
            }

            requestAnimationFrame(animation);
        });
    }

    function initVideoPlayback() {
        const playButtons = document.querySelectorAll('.lp-supporters-video__play-btn');
        const videoModal = document.getElementById('video-modal');
        const videoIframe = document.getElementById('video-iframe');
        const closeBtn = document.querySelector('.video-modal__close');
        const overlay = document.querySelector('.video-modal__overlay');

        if (!videoModal) return;

        // Function to extract video ID from various YouTube URL formats
        function getYouTubeEmbedUrl(url) {
            let videoId = '';

            // Handle youtu.be short URL
            if (url.includes('youtu.be/')) {
                videoId = url.split('youtu.be/')[1].split('?')[0].split('&')[0];
            }
            // Handle youtube.com watch URL
            else if (url.includes('youtube.com/watch')) {
                const params = new URLSearchParams(url.split('?')[1]);
                videoId = params.get('v');
            }
            // Handle youtube.com embed URL
            else if (url.includes('youtube.com/embed/')) {
                videoId = url.split('youtube.com/embed/')[1].split('?')[0].split('&')[0];
            }

            if (videoId) {
                return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            }

            return null;
        }

        // Close modal functions
        function closeModal() {
            videoModal.classList.remove('is-open');
            videoIframe.src = '';
        }

        // Close button click
        closeBtn.addEventListener('click', closeModal);

        // Overlay click to close
        overlay.addEventListener('click', closeModal);

        // Escape key to close
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && videoModal.classList.contains('is-open')) {
                closeModal();
            }
        });

        // Play button click
        playButtons.forEach((button) => {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                // Get video link from data attribute
                const videoLink = button.getAttribute('data-video-url');

                if (!videoLink) {
                    console.warn('No video URL provided. Add data-video-url attribute to the play button.');
                    return;
                }

                // Convert URL to embed format
                const embedUrl = getYouTubeEmbedUrl(videoLink);

                if (!embedUrl) {
                    console.warn('Invalid YouTube URL. Please use a valid YouTube link.');
                    return;
                }

                // Set iframe src and open modal
                videoIframe.src = embedUrl;
                videoModal.classList.add('is-open');
            });
        });
    }

    /**
     * @param {Event} event
     */
    function toggleFAQ(event) {
        const button = /** @type {HTMLElement} */ (event.currentTarget);
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        const answerId = button.getAttribute('aria-controls');
        if (!answerId) return;
        const answer = document.getElementById(answerId);

        if (!answer) return;

        if (isExpanded) {
            // Close
            button.setAttribute('aria-expanded', 'false');
            answer.removeAttribute('hidden');
            answer.classList.remove('faq__answer--open');
            // Force reflow for animation
            void answer.offsetHeight;
            answer.setAttribute('hidden', '');
        } else {
            // Open
            button.setAttribute('aria-expanded', 'true');
            answer.removeAttribute('hidden');
            answer.classList.add('faq__answer--open');
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initFAQ();
            initStickyProductCard();
            initCTAScroll();
            initVideoPlayback();
        });
    } else {
        initFAQ();
        initStickyProductCard();
        initCTAScroll();
        initVideoPlayback();
    }
})();